var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Row",
    { attrs: { gutter: 16 } },
    [
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "高度" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.gaoDu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "gaoDu", $$v)
                  },
                  expression: "descJson.gaoDu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "冠幅" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.guanFu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "guanFu", $$v)
                  },
                  expression: "descJson.guanFu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "株高" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.zhuGao,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "zhuGao", $$v)
                  },
                  expression: "descJson.zhuGao",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "叶片数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.yePianShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "yePianShu", $$v)
                  },
                  expression: "descJson.yePianShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "不正常叶数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.buZhengChangYeShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "buZhengChangYeShu", $$v)
                  },
                  expression: "descJson.buZhengChangYeShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "根系状态" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.genXiZhuangTai,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "genXiZhuangTai", $$v)
                  },
                  expression: "descJson.genXiZhuangTai",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "弯曲度" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.wanQuDu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "wanQuDu", $$v)
                  },
                  expression: "descJson.wanQuDu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "重量" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.zhongLiang,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "zhongLiang", $$v)
                  },
                  expression: "descJson.zhongLiang",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "花苞数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.huaBaoShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "huaBaoShu", $$v)
                  },
                  expression: "descJson.huaBaoShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "高度差茎秆" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.gaoDuChaJingGan,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "gaoDuChaJingGan", $$v)
                  },
                  expression: "descJson.gaoDuChaJingGan",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "病虫害" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.bingChongHai,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "bingChongHai", $$v)
                  },
                  expression: "descJson.bingChongHai",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "土壤湿度" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.tuRangShiDu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "tuRangShiDu", $$v)
                  },
                  expression: "descJson.tuRangShiDu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "开放度" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.kaiFangDu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "kaiFangDu", $$v)
                  },
                  expression: "descJson.kaiFangDu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "机械损伤" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.jiXieSunShang,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "jiXieSunShang", $$v)
                  },
                  expression: "descJson.jiXieSunShang",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "株数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.zhuShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "zhuShu", $$v)
                  },
                  expression: "descJson.zhuShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "花数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.huaShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "huaShu", $$v)
                  },
                  expression: "descJson.huaShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "枝条数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.zhiTiaoShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "zhiTiaoShu", $$v)
                  },
                  expression: "descJson.zhiTiaoShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "节间高度" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.jieJianGaoDu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "jieJianGaoDu", $$v)
                  },
                  expression: "descJson.jieJianGaoDu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "芽数" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.yaShu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "yaShu", $$v)
                  },
                  expression: "descJson.yaShu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "粗度" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.chuDu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "chuDu", $$v)
                  },
                  expression: "descJson.chuDu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "球茎" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.qiuJing,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "qiuJing", $$v)
                  },
                  expression: "descJson.qiuJing",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "花型" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.huaXing,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "huaXing", $$v)
                  },
                  expression: "descJson.huaXing",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Col",
        { attrs: { span: "6" } },
        [
          _c(
            "FormItem",
            { attrs: { label: "叶幅" } },
            [
              _c("Input", {
                attrs: { readonly: _vm.readOnly },
                model: {
                  value: _vm.descJson.yeFu,
                  callback: function ($$v) {
                    _vm.$set(_vm.descJson, "yeFu", $$v)
                  },
                  expression: "descJson.yeFu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }